import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PermissionsService } from 'shared-lib';
@Component({
  selector: 'app-adv-switch-buttons',
  templateUrl: './adv-switch-buttons.component.html',
  styleUrls: ['./adv-switch-buttons.component.scss'],
  standalone: false,
})
export class AdvSwitchButtonsComponent implements OnInit, OnChanges {

  constructor(
    private toastr: ToastrService,
    public permissionsService: PermissionsService
  ){}

  @Output() buttonClicked = new EventEmitter<string>();
  @Input() initBtnClicked: string;
  @Input() isOnMap: boolean;

  btnActive: string = '';

  mapBtnStyles: { backgroundColor: string, color: string, boxShadow: string };
  aiMapBtnStyles: { backgroundColor: string, color: string, boxShadow: string };
  treeBtnStyles: { backgroundColor: string, color: string, boxShadow: string };
  schematicBtnStyles: { backgroundColor: string, color: string, boxShadow: string };

  ngOnChanges(changes: SimpleChanges): void {
    this.changeStylesByButtonActive(this.btnActive)
  }
  ngOnInit(): void {
    this.mapBtnStyles = {
      backgroundColor: '#17171A',
      color: '#fff',
      boxShadow: '0px 2px 6px 0px #00000012',
    };
    this.aiMapBtnStyles = {
      backgroundColor: '#fff',
      color: '#000',
      boxShadow: '0px 2px 6px 0px #00000012',
    };
    this.treeBtnStyles = {
      backgroundColor: 'inherit',
      color: '#171717',
      boxShadow: 'none',
    };
    this.schematicBtnStyles = {
      backgroundColor: 'inherit',
      color: '#171717',
      boxShadow: 'none',
    };

    this.changeStylesByButtonActive(this.initBtnClicked);
  }

  onButtonClick(buttonClass: string) {
    this.btnActive = buttonClass;
    this.changeStylesByButtonActive(this.btnActive);
    this.buttonClicked.emit(this.btnActive);
  }

  private changeStylesByButtonActive(btn: string): void {
    if (btn == 'map-btn') {
      this.mapBtnStyles = {
        backgroundColor: '#17171A',
        color: '#fff',
        boxShadow: '0px 2px 6px 0px #00000012',
      }
      this.treeBtnStyles = {
        backgroundColor: 'inherit',
        color: '#171717',
        boxShadow: 'none',
      };
      this.aiMapBtnStyles = {
        backgroundColor: '#fff',
        color: '#000',
        boxShadow: 'none',
      }
      this.schematicBtnStyles = {
        backgroundColor: 'inherit',
        color: '#171717',
        boxShadow: 'none',
      };
    } else if (btn == 'tree-btn') {
      this.mapBtnStyles = {
        backgroundColor: 'inherit',
        color: '#171717',
        boxShadow: 'none',
      }
      this.aiMapBtnStyles = {
        backgroundColor: 'inherit',
        color: '#000F3366',
        boxShadow: 'none',
      }
      this.schematicBtnStyles = {
        backgroundColor: 'inherit',
        color: '#171717',
        boxShadow: 'none',
      };
      this.treeBtnStyles = {
        backgroundColor: '#17171A',
        color: '#fff',
        boxShadow: '0px 2px 6px 0px #00000012',
      }
    }
    else if (btn == 'ai-map-btn') {
       this.mapBtnStyles = {
        backgroundColor: '#fff',
        color: '#000',
        boxShadow: 'none',
      }
      this.treeBtnStyles = {
        backgroundColor: 'inherit',
        color: '#171717',
        boxShadow: 'none',
      };
      this.schematicBtnStyles = {
        backgroundColor: 'inherit',
        color: '#171717',
        boxShadow: 'none',
      };
      this.aiMapBtnStyles = {
        backgroundColor: '#fff',
        color: '#000',
        boxShadow: 'none',
      }
    } else if (btn == 'schematic-btn') {
      this.mapBtnStyles = {
        backgroundColor: 'inherit',
        color: '#171717',
        boxShadow: 'none',
      }
      this.aiMapBtnStyles = {
        backgroundColor: 'inherit',
        color: '#000F3366',
        boxShadow: 'none',
      }
      this.schematicBtnStyles = {
        backgroundColor: '#17171A',
        color: '#fff',
        boxShadow: '0px 2px 6px 0px #00000012',
      }
      this.treeBtnStyles = {
        backgroundColor: 'inherit',
        color: '#171717',
        boxShadow: 'none',
      };
    }
  }

}
